import { ParseOptions } from "query-string";
import { MULTIPLE_VALUES_IN_URL_SEPARATOR } from "shared/utils/constants";

export const defaultParseOptions: ParseOptions = {
  arrayFormat: "index",
  arrayFormatSeparator: MULTIPLE_VALUES_IN_URL_SEPARATOR,
  parseBooleans: true
};
